import { render } from "./Transfers.vue?vue&type=template&id=3e6ea9dc"
import script from "./Transfers.vue?vue&type=script&lang=js"
export * from "./Transfers.vue?vue&type=script&lang=js"
script.render = render

export default script